import React from 'react';
import BreakdownRingChart from '../../../../../../shared/designSystem/components/BreakdownRingChart';

// PublisherRingChart is now a thin alias for the shared BreakdownRingChart.
// Preserves the legacy call-site shape (`selectedPublisherDimension`) while
// delegating all render logic to the design-system component.
const PublisherRingChart = ({ data, height, selectedPublisherDimension }) => (
  <BreakdownRingChart
    data={data}
    dimension={selectedPublisherDimension}
    height={height}
  />
);

export default PublisherRingChart;
